import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"

const TypeShade = () => {
  const data = useStaticQuery(graphql`
    query {
      imageOne: file(relativePath: { eq: "projects_05/gallery/img_002.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageTwo: file(relativePath: { eq: "projects_05/gallery/img_003.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageThree: file(relativePath: { eq: "projects_05/gallery/img_004.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Layout>
      <section class="body_center">
      <div class="body_center">
        <div className = "grid-layout-image3">
          <iframe src="https://giphy.com/embed/UqkKYgFMQiZWppr6AY" width="480" height="286" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
          
          <iframe src="https://giphy.com/embed/Q5iFDryNFReAbFlkUg" width="480" height="270" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
      </div>
      </div>

        <div>
          <h1 class="mainTitle">TypeMotion_02</h1>
        </div>
        <p>
         TypeMotion_02 is a series of experiments that explore proceedural animation of text. Inspired by <a href="https://timrodenbroeker.de/processing-tutorial-kinetic-typography-1/">Tim Rodenbroeker's kinetic typography work</a> and <a href="https://dia.tv/">studio DIA's</a> amazing work, I wanted to explore the potential for myself and delve into a little shader treatment too. Here is a humble presentation of tiny experiments which I hope will take on further form in the not so distant future. 
        </p>

        <p class="notes">
          Project type : Formal research<br></br>
          Tools used : GLSL, Processing, fonts<br></br>
          Code Repository :{" "}
          <a href="https://bitbucket.org/mwebster_/dithering/src/master/">
            DitherT Repo
          </a>
        </p>
      </section>


      <div class="body_center">
      <div className = "grid-layout-image3">
          
          <iframe src="https://giphy.com/embed/dCKPKSgsWlJm5N45iL" width="480" height="204" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
          <iframe src="https://giphy.com/embed/WQm9FFhIz6RDriDzVT" width="480" height="250" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
          <iframe src="https://giphy.com/embed/QuhSRquprvc8jcRpPV" width="480" height="272" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
          <iframe src="https://giphy.com/embed/Qwsnl7mBIlVwJEACZO" width="480" height="270" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>

          
        </div>
        <p class="legend">TypeMotion_02 Experiments. 2019</p>
        </div>

        <section class="body_center">
        <p>
          The above excerpts are all early tests that apply a few basic shader programs - sobel, channels and pixelisation. The static images below come from another program that applies dithering as well as channel manipulation. The idea here was to build on an early experimental program I wrote called <Link to="/dither">DitherType.</Link> Again, I believe there is potential for working with students with this, introducing concepts such as proceedural animation, harmonic motion and letter form. Kinetic work like this is visually intriguing and as much as I can enjoy graphics in motion, I also appreciate the possibilities of static images like these which could be used for print. Composing images that express dynamic movement is as much a pleasure as a challenge for me.
        </p>
      </section>

        <section class="body_wide">
      <Img fluid={data.imageOne.childImageSharp.fluid} />
        <p class="legend">TypeMotion_02 Research_003. 2019</p>
      </section>
      <section class="body_wide">
      <Img fluid={data.imageTwo.childImageSharp.fluid} />
        <p class="legend">TypeMotion_02 Research_004. 2019</p>
      </section>
      <section class="body_wide">
      <Img fluid={data.imageThree.childImageSharp.fluid} />
        <p class="legend">TypeMotion_02 Research_005. 2019</p>
      </section>

    </Layout>
  )
}

export default TypeShade